import { deleteDoc, doc } from 'firebase/firestore';

import { CollectionOptions, getCollection } from './helpers';

export const deletePushToken = async (token: string) => {
  const tokenDoc = doc(getCollection(CollectionOptions.FcmTokens), token);
  deleteDoc(tokenDoc);
};
